<template>
    <div>
        <breadcrumb :routerList="[{to:'/credit',title:'信贷管理'},{title:'信贷管理'}]"/>
		<div class="h-content">
			<div class="h-piece">
				<div class="h-formBox">
					<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					  <el-form-item label="客户名称">
						<el-input v-model="formInline.username" placeholder="模糊查询"></el-input>
					  </el-form-item>
					  <el-form-item label="签约时间">
						<el-col :span="11">
						  <el-date-picker type="date" placeholder="选择时间" v-model="formInline.startCdate" style="width: 1.6rem;"></el-date-picker>
						</el-col>
                      <el-col class="line h-txtCenter" :span="2">至</el-col>
                      <el-col :span="11">
                          <el-date-picker type="date" placeholder="选择时间" v-model="formInline.endCdate" style="width: 1.6rem;"></el-date-picker>
                      </el-col>
					  </el-form-item>
					 
					  <el-form-item class="h-formBtnOut">
						<el-button class="h-btn h-formBtn" @click="checkData">检索</el-button>
                          <el-button class="h-btn h-formBtn" @click="resetData" style="background-color:white;color:black;border:1px solid #d1d1d1">重置</el-button>
					  </el-form-item>
					</el-form>
				</div>
			</div>
            <div class="h-row">
				<div class="h-rowIn" style="width:100%;">
                    <el-table
                        ref="multipleTable"
                        @selection-change="handleSelectionChange"
                        :data="tableData2"
                        stripe
                        style="width: 100%"
						border
                        :default-sort = "{prop: 'times', order: 'descending'}"
                        >
                        <el-table-column
                        type="selection"
                        width="55"
                        label="全选"
                        >
                        </el-table-column>
                        <el-table-column
                        type="index"
                        width="40"
                        label="#">
                        </el-table-column>
                        <el-table-column
                        prop="username"
                        label="客户名称"
						 :show-overflow-tooltip="true"
                        min-width="250">
						<template slot-scope="scope">
							<div style="text-align: left;">{{scope.row.username}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                        prop="amount"
						width="100"
                        label="账户余额">
                        </el-table-column>
                        <el-table-column
                        prop="quota"
						width="100"
                        label="信贷余额">
                        </el-table-column>
                        <el-table-column
                        prop="cashed"
						width="100"
                        label="返利金额">
                        </el-table-column>
                        <el-table-column
                        prop="salesRegion"
						width="100"
                        label="销售区域"
						 :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                        prop="ymoney"
						width="100"
                        label="逾期金额">
                        </el-table-column>
                        <el-table-column
                        prop="cdate"
						width="120"
                        label="签约时间"
						 :show-overflow-tooltip="true"
                        sortable>
                        </el-table-column>
                        <el-table-column
                        label="操作"
                        fixed="right"
						width="100"
                        >
                        <template slot-scope="scope">
                            <el-button
                            type="text"
                            size="small"
                            class="h-tableLink h-btn"
                            @click="showDetail(scope.row)">
                                    查看
                            </el-button>
							<!-- <div class="l-operationBox">
								<span class="l-operationlist br-operation-look" title="查看" @click="showDetail(scope.row)"></span>
							</div> -->
                        </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="download">批量导出</el-button>
<!--                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export">批量导入</el-button>-->
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="choose"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import creditService from "../../../api/loud/credit/creditService";
    import util from "../../../utils/util";

export default {
    data(){
        return{

            names:'',
            input1:'',
            sele:'工程',
            formInline:{
				username:null,
				startCdate:null,
				endCdate:null,
                pageSize:10,
                pageNo:1,
            },
            multipleSelection: [],
            //信贷列表
            tableData2: [],
            q: {
                pageSize:10,
                pageNo:1,
                total:0
            },
            isCheck: false
        }
    },
    created(){
        this.queryList();
    },
    methods:{
        showDetail(v){
            this.$router.push({path: "/customerDetails", query: v});
        },
        //导出excel
        download(){
            //ids
            var cc = [];
            for (var d in this.tableData2.id) {
                cc.push(this.tableData2.records[d].id);
            }
            //查询参数
            var c = {
                ids: cc,
            };
            creditService.download(c);
        },
        //分页查询选择
        choose(){
            if (this.isCheck){
                this.checkData();
            }else{
                this.queryList();
            }
        },
        //检索按钮功能
        checkData(){
            this.isCheck = true;
            this.formInline.pageNo = this.q.pageNo;
            this.formInline.pageSize = this.q.pageSize;
            if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.startCdate))){
                if (this.formInline.startCdate!==null){
                    this.formInline.startCdate = util.riQi3(this.formInline.startCdate);
                }
            }
            if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.endCdate))){
                if (this.formInline.endCdate){
                    this.formInline.endCdate = util.riQi3(this.formInline.endCdate);
                }
            }
            creditService.query(this.formInline).then(response => {
                this.tableData2 = response.records;
                this.q.total = response.total;
                for (var i=0;i<this.tableData2.length;i++){
                    if (this.tableData2[i].isOverdue===1){
                        this.tableData2[i].ymoney = this.tableData2[i].maxquota - this.tableData2[i].quota;
                    }else{
                        this.tableData2[i].ymoney = 0;
                    }
                }
            })
        },
        //重置按钮功能
        resetData(){
            this.formInline.username = null;
            this.formInline.startCdate = null;
            this.formInline.endCdate = null;
            this.formInline.pageSize = 10;
            this.formInline.pageNo = 1;
        },
        //查询信贷列表分页
        queryList(){
            creditService.query(this.q).then(response => {
                console.log(response,'查询信贷列表分页')
                this.tableData2 = response.records
                this.q.total = response.total;
                //查询逾期金额列表，存到tableData2数组的每个对象中------ymoney
                for (var i=0;i<this.tableData2.length;i++){
                    if (this.tableData2[i].isOverdue===1){
                        this.tableData2[i].ymoney = this.tableData2[i].maxquota - this.tableData2[i].quota;
                    }else{
                        this.tableData2[i].ymoney = 0;
                    }
                }
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleSizeChange(){
            console.log(1)
        },
        handleCurrentChange(){
            console.log(2)
        }
    }
}
</script>
<style scoped>

/* .selectorBox{
    width: 100%;
    padding: 0.54rem 0.28rem 0 0.25rem;
}
.selectorBox .text{
    margin-left: 0.38rem;
    font-size: 0.18rem;
    color: #4a4a4a;
    position: relative;
}
.selectorBox .text::before{
    content: "*";
    position: absolute;
    top: 0;
    left: -7px;
    color: red;
    font-size: 0.2rem;
}
.selectorBox .selector{
    margin-left: 0.38rem;
    margin-top: 20px;
    display: flex;
}
.selectorBox .selector .button{
    width: 65px;
    padding: 10px;
    color: #b7b7b7;
    border: 1px solid #dcdfe1;
    text-align: center;
    line-height: 20px;
    cursor: pointer;
}
.selectorBox .selector .button.active{
    color: #fff;
    background: #238cfd;
    border: 1px solid #238cfd;
}
.tip{
    margin-left: 1.6rem;
    color: #b0b0b0;
    font-size: 0.2rem;
    margin-top:10px;
}
.h-bgccc{
    background: #edf5fa;
    border-color: #959595;
    color: #92999e;
} */
</style>
<style>
/* .selectorBox .el-input-group__append{
    background: #238cfd;
    color: #fff
}
.selectorBox .el-upload-list{
    display: none;
} */
</style>